/**
 * Match logged-in user to EMS trainer rows: application_user_id first,
 * then organization_user_id vs trainer_employee_id (legacy shapes).
 */

function trimId(v) {
  if (v == null || v === "") return "";
  return String(v).trim();
}

export function getLoggedInApplicationUserId(userData) {
  if (!userData) return "";
  const top = userData.application_user_id;
  if (top != null && trimId(top)) return trimId(top);
  const loginuser = userData.loginuser;
  const first = Array.isArray(loginuser) ? loginuser[0] : loginuser;
  if (!first) return "";
  const fromLogin =
    first.application_user_id ??
    first.application_user?.application_user_id ??
    (Array.isArray(first.applicationuser)
      ? first.applicationuser[0]?.application_user_id
      : null) ??
    (typeof first.applicationuser === "object" && first.applicationuser
      ? first.applicationuser.application_user_id
      : null) ??
    first.organization_user?.application_user_id ??
    first.organization_person?.application_user?.application_user_id ??
    "";
  return trimId(fromLogin);
}

export function getLoggedInOrganizationUserId(userData) {
  const loginuser = userData?.loginuser;
  const first = Array.isArray(loginuser) ? loginuser[0] : loginuser;
  const id =
    first?.organization_user_id ??
    first?.organization_user?.organization_user_id ??
    first?.organization_person?.organization_user_id;
  return trimId(id);
}

export function getApplicationUserIdFromTrainerObject(t) {
  if (!t || typeof t !== "object") return "";
  const candidates = [
    t.application_user_id,
    Array.isArray(t.applicationuser) ? t.applicationuser[0]?.application_user_id : null,
    t.applicationuser?.application_user_id,
    Array.isArray(t.application_user) ? t.application_user[0]?.application_user_id : null,
    t.application_user?.application_user_id,
    t.organization_user?.application_user_id,
    Array.isArray(t.organization_user?.application_user)
      ? t.organization_user.application_user[0]?.application_user_id
      : null,
    t.organization_user?.applicationuser?.[0]?.application_user_id,
    t.organization_person?.application_user?.application_user_id,
  ];
  for (const c of candidates) {
    const s = trimId(c);
    if (s) return s;
  }
  return "";
}

export function getTrainerApplicationUserIdFromRow(row) {
  if (!row || typeof row !== "object") return "";
  const direct = trimId(row.trainer_application_user_id);
  if (direct) return direct;
  const t = row.trainer;
  if (t && typeof t === "object") {
    const fromT = getApplicationUserIdFromTrainerObject(t);
    if (fromT) return fromT;
  }
  const nested =
    row.batchClass?.trainer ??
    row.batch_class?.trainer ??
    row.batchClassRecord?.batchClass?.trainer ??
    row.batch_class_record?.batch_class?.trainer ??
    row.batchClassRecord?.batch_class?.trainer ??
    row.batchClassRecord?.trainer ??
    row.batch_class_record?.trainer ??
    row.class_record?.trainer ??
    row.demo_session?.trainer ??
    row.demoSession?.trainer;
  const fromNested = getApplicationUserIdFromTrainerObject(nested);
  if (fromNested) return fromNested;
  return "";
}

export function getTrainerOrganizationUserIdFromRow(row) {
  if (!row || typeof row !== "object") return "";
  const t = row.trainer;
  const fromBatch =
    row.batchClass?.trainer_employee_id ??
    row.batch_class?.trainer_employee_id ??
    row.batchClassRecord?.batchClass?.trainer_employee_id ??
    row.batch_class_record?.batch_class?.trainer_employee_id ??
    row.batchClassRecord?.batch_class?.trainer_employee_id;
  const v =
    row.trainer_employee_id ??
    fromBatch ??
    t?.organization_user_id ??
    t?.organization_user?.organization_user_id ??
    "";
  return trimId(v);
}

export function emsRowMatchesLoggedInTrainer(row, userData) {
  const loggedApp = getLoggedInApplicationUserId(userData);
  const rowApp = getTrainerApplicationUserIdFromRow(row);
  if (loggedApp && rowApp) return loggedApp === rowApp;
  const loggedOrg = getLoggedInOrganizationUserId(userData);
  const rowOrg = getTrainerOrganizationUserIdFromRow(row);
  if (loggedOrg && rowOrg) return loggedOrg === rowOrg;
  return false;
}

export function emsBatchListRowMatchesLoggedInTrainer(row, userData) {
  const loggedApp = getLoggedInApplicationUserId(userData);
  if (loggedApp) {
    const precomputed = row?.trainer_application_user_ids;
    if (Array.isArray(precomputed) && precomputed.length) {
      if (precomputed.some((id) => trimId(id) === loggedApp)) return true;
    }
    const trainers = row?.batch_trainers ?? row?.batch?.batch_trainers;
    if (Array.isArray(trainers)) {
      for (const bt of trainers) {
        const t = bt?.trainer ?? bt;
        const aid = getApplicationUserIdFromTrainerObject(t);
        if (aid && aid === loggedApp) return true;
      }
    }
    const single = row?.trainer ?? row?.batch?.trainer;
    if (single && typeof single === "object") {
      const singleApp = getApplicationUserIdFromTrainerObject(single);
      if (singleApp && singleApp === loggedApp) return true;
    }
  }
  const loggedOrg = getLoggedInOrganizationUserId(userData);
  if (!loggedOrg) return false;
  const ids = Array.isArray(row?.trainer_employee_ids)
    ? row.trainer_employee_ids
    : [];
  return ids.some((id) => trimId(id) === loggedOrg);
}
